import { gql, useQuery } from '@apollo/client'

export type Community = {
	id: string
	title: string
	lat: string
	lon: string
	parentRestaurantMinOrderValueInCents?: number
	parentRestaurantDeliveryFeeDefaultInCents?: number
	parentRestaurantActive?: boolean
	parentRestaurantNSubOrdersPerOrder?: number
	parentRestaurantClosingMinutesBeforeDelivery?: number
}

export const ACTIVE_COMMUNITIES_QUERY = gql`
	query ActiveCommunities {
		communities(active: true) {
			id
			title
		}
	}
`

export const useActiveCommunities = (): Community[] | undefined => {
	const { data } = useQuery(ACTIVE_COMMUNITIES_QUERY)
	return data?.communities as Community[] | undefined
}
